module.exports = __webpack_public_path__ + "05_glasses_brown.d2abeae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/05_glasses_brown.png
// module id = e8u/
// module chunks = 0